<template>
  <base-view edition="2025" />
</template>

<script>
import BaseView from "@/views/BaseView";

export default {
  components: {
    BaseView,
  },
};
</script>
